import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiClient } from '../../../shared';
import { ItemProfitabilityRow } from '../../item-profitibility-report/item-profitability-row';
import { TransportJobReportRow } from '../../transport-jobs-report/transport-job-report-row';
import { ReportCriteriaItemModel } from '../models/report-criteria-item.model';
import { PaginatedResponse } from 'src/app/models/paginated-response';
@Injectable()
export class ReportService {
  orderBy: string;
  orderDirection: string;

  constructor(private http: ApiClient) {}

  getReportControl(criterion: ReportCriteriaItemModel) {
    switch (criterion.type) {
      case 'fromToDate':
        return new UntypedFormGroup({
          from: new UntypedFormControl(''),
          to: new UntypedFormControl('')
        });
    }
  }

  getItemProfitability(qs: string) {
    return this.http.get<ItemProfitabilityRow[]>(
      `reports/item-profitability${qs}`
    );
  }

  getTransportJobReport(
    params: {
      from: string | null;
      to: string | null;
      assignedTo: number | null;
    },
    pagination: {
      page: number;
      perPage: number;
      sortBy: string;
      sortOrder: string;
    }
  ) {
    const paginationQs = `page=${pagination.page + 1}&perPage=${pagination.perPage}&sortBy=${pagination.sortBy}&sortOrder=${pagination.sortOrder}`;
    return this.http.post<PaginatedResponse<TransportJobReportRow>>(
      `reports/transport-jobs?${paginationQs}`,
      params
    );
  }

  exportTransportJobReport(params: {
    from: string | null;
    to: string | null;
    assignedTo: number | null;
  }) {
    return this.http.post(`reports/transport-jobs`, params, {
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }
}
